export default __webpack_public_path__ + "static/media/planet-avatar-02.9afe1245.png";